import PropTypes from 'prop-types';
import React from 'react';
import FreeformEmailInput from './components/FreeformEmailInput';
import SingleDomainEmailInput from './components/SingleDomainEmailInput';
import MultiDomainEmailInput from './components/MultiDomainEmailInput';
import './index.css';

const EmailInput = props => {
  switch (props.domains.length) {
    case 0:
      return <FreeformEmailInput {...props} />;
    case 1:
      return <SingleDomainEmailInput {...props} />;
    default:
      return <MultiDomainEmailInput {...props} />;
  }
};

EmailInput.propTypes = {
  domains: PropTypes.array.isRequired,
  onEmailChange: PropTypes.func.isRequired,
};

export default EmailInput;
